import Axios from "axios";
import { SET_LEAD_STATUS_ROUTES_LIST, UNSET_LEAD_STATUS_ROUTES_LIST } from "@/store/mutation-types";
import { getSalesLeadStatus } from "@/store/api";

// initial state
const state = {
    getSalesLeadStatus: [],
};

const getters = {
    getSalesLeadStatus(state) {
        return state.getSalesLeadStatus;
    },
};

const mutations = {
    [SET_LEAD_STATUS_ROUTES_LIST](state, data) {
        state.getSalesLeadStatus = data;
    },
    [UNSET_LEAD_STATUS_ROUTES_LIST](state) {
        state.getSalesLeadStatus = [];
    },
};

const actions = {
    getSalesLeadStatus({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getSalesLeadStatus, data)
                .then(function (response) {
                    commit("SET_LEAD_STATUS_ROUTES_LIST", response.data.data);
                    resolve(response);
                })
                .catch(function (error) {
                    commit("UNSET_LEAD_STATUS_ROUTES_LIST");
                    reject(error);
                })
                .then((always) => { });
        });
    },

    getSalesLeadStatusById({ commit }, data) {
        const getSalesLeadStatusById = `${getSalesLeadStatus}/${data}`;
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.get(getSalesLeadStatusById)
                .then((response) => {
                    resolve(response.data.code);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
